import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { ClientService } from '../services/client.service';
import { AuthService } from '../services/auth.service';
import { SetupWizardState } from '@mira-avant/mtlibs';

export const setupWizardClientPickerGuard: CanActivateFn = async (route, state) => {
	const router = inject(Router);
	const clientService = inject(ClientService);
	const authService = inject(AuthService);

	const isAdmin = await authService.isAdmin$();

	if (isAdmin) {
		// Admins get to see the client picker render so they can choose a client
		return true;
	} else {
		const client = await clientService.getClientBySubDomain$();

		if (!client?.uuid) {
			console.error('No client found for subdomain');

			return router.createUrlTree(['/']);
		}

		// Non admins get redirected to their client's dashboard
		return router.createUrlTree(['my', 'admin', 'setup-wizard', SetupWizardState.DASHBOARD, client.uuid]);
	}
};
